import { render, staticRenderFns } from "./instagramPosts.vue?vue&type=template&id=9b92fab8&scoped=true&"
import script from "./instagramPosts.vue?vue&type=script&lang=js&"
export * from "./instagramPosts.vue?vue&type=script&lang=js&"
import style0 from "./instagramPosts.vue?vue&type=style&index=0&id=9b92fab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b92fab8",
  null
  
)

export default component.exports